import { Controller } from "stimulus";
import { initDatepicker, initTimepicker } from "controllers/utilities/datepicker.js";

export default class extends Controller {
  static targets = ['input'];

  connect() {
    this.type = this.data.get('type');

    if (this.type === 'datetime') {
      this.picker = flatpickr(this.inputTarget, {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: true,
        allowInput: true
      });
    }
    else if (this.type === 'time') {
      this.picker = initTimepicker(this.inputTarget);
    }
    else if (this.type === 'birthdate') {
      this.picker = initDatepicker(this.inputTarget);
      this.picker.config.onOpen.push(this.setDefaultDate.bind(this));
    }
    else {
      this.picker = initDatepicker(this.inputTarget);
    }
  }

  clear(e) {
    e.preventDefault();
    this.picker.clear();
  }

  setDefaultDate() {
    if (!this.picker.selectedDates.length) {
      this.picker.setDate(new Date(2002, 0, 1));
    }
  }
}
